export const quizUrl = '/wedding-vendors/budget-quiz';
